export function isDateWithinRange(date, start, end) {
    if (start != null && date < start) {
        return false;
    }
    if (end != null && date > end) {
        return false;
    }
    return true;
}
//# sourceMappingURL=isDateWithinRange.js.map